export default function HandleCloseAlert() {
    if (document.querySelector('.form-alert')) {
        document
            .querySelector('.form-alert-close')
            .addEventListener('click', e => {
                e.preventDefault();
                document.querySelector('.form-alert').remove();
            });
    }
}
